export default __webpack_public_path__ + "static/michigan-2-62013b954192754052aa4480ab4b66ad.jpg";